import { createSelector } from "reselect";
import getProfessionEditedFieldsSelector from "./getProfessionEditedFieldsSelector";

export default createSelector(
    getProfessionEditedFieldsSelector,
    (_: Store, field: string) => field,
    (fields, field) => fields[field]
);
